
<template>
  <div class="securitygroups" v-if="locale.securitygroups">
    <template v-if="loadingState">
      <div class="spinner">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 200 117" style="enable-background:new 0 0 200 117;" xml:space="preserve">
            <g id="triangle8">
                <path class="st0" d="M153,60.4l-22,10.9l22-31.4V60.4z"/>
            </g>
            <g id="triangle7">
                <path class="st1" d="M131,71.2l-24.4-25l46.4-6.5L131,71.2z"/>
            </g>
            <g id="triangle6">
                <path class="st2" d="M131,71.2L111.1,90l-4.5-43.8L131,71.2z"/>
            </g>
            <g id="triangle5">
                <path class="st0" d="M109.6,76.1l-2.2-21.5l0.3,21.4L109.6,76.1z"/>
            </g>
            <g id="triangle4">
                <path class="st1" d="M106.6,46.2l0.8,8.3l0.3,21.4l-23.2-1.5L106.6,46.2z"/>
            </g>
            <g id="triangle3">
                <path class="st3" d="M84.5,74.5L59.6,51l47-4.7L84.5,74.5z"/>
            </g>
            <g id="triangle2">
                <polygon class="st0" points="50.5,52 37.9,30.5 69.7,60.4"/>
            </g>
            <g id="triangle1">
                <path class="st2" d="M50.5,52l-12,18.3L59.6,56L50.5,52z"/>
            </g>
        </svg>
      </div>
    </template>
    <template v-if="!loadingState">
    <div class="content-headline">
      <div class="content-headline__wrapper">
        <h1>{{locale.securitygroups.title}} - {{locale.securitygroups.groups}}</h1>
        <div class="content-headline__control-buttons">
          <button class="button action-tooltip" v-on:click="openModal({ 'id': 'modalNewGroup'})">{{locale.securitygroups.buttonNewGroup}}</button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table class="responsive">
        <thead>
        <tr>
          <th scope="col">{{locale.securitygroups.name}}</th>
          <th scope="col">{{locale.securitygroups.description}}</th>
          <th scope="col"></th>
        </tr>
        </thead>
        <tbody>
          <template v-for="securitygroup in securitygroups">
            <tr :key="securitygroup.name">
              <td data-label="Name"><router-link :to="{ name: 'SecurityGroupRules', params: { id: securitygroup.id } }">{{securitygroup.name}}</router-link></td>
              <td data-label="Description">{{securitygroup.description}}</td>
              <td data-label="Action">
                <a href="#" v-on:click="openModal({ id: 'modalDelete', data: securitygroup})">
                  <span class="actions-icon actions-icon--trash"></span>
                </a>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <ModalBox id="modalNewGroup">
      <template slot="header">
        {{locale.securitygroups.modal.newgroup.title}}:
      </template>
      <template slot="body">
        <form class="form" @submit.prevent="submit">
          <label>{{locale.securitygroups.modal.newgroup.name}}</label>
          <input type="text" v-model="form.name"/>
          <label>{{locale.securitygroups.modal.newgroup.description}}</label>
          <textarea type="text" v-model="form.description"/>
          <div class="modal-buttons">
            <button class="button" v-on:click="closeModal({ 'id': 'modalNewGroup' })">{{locale.securitygroups.modal.newgroup.submit}}</button>
          </div>
        </form>
      </template>
    </ModalBox>
    <ModalBox id="modalDelete">
      <template slot="header">
        {{locale.securitygroups.modal.delete.title}}
      </template>
      <template slot="body">
        <div class="modal-buttons">
          <a href="#" class="button button--secondary" v-on:click="closeModal({id: 'modalDelete'})">{{locale.securitygroups.modal.delete.cancel}}</a>
          <a href="#" class="button button--danger"
             v-on:click="deleteGroup(modalData) + closeModal({id: 'modalDelete'})">{{locale.securitygroups.modal.delete.button}}</a>
        </div>
      </template>
    </ModalBox>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalBox from '../utils/modalBox.vue'

export default {
  name: 'SecurityGroups',
  components: { ModalBox },
  computed: {
    ...mapState(['locale']),
    ...mapState({
      securitygroups: state => state.securitygroups.securitygroups,
      loadingState: state => state.loadingState,
      modalData: state => state.modal.modalData
    })
  },
  data: function () {
    return {
      interval: null,
      form: []
    }
  },
  mounted () {
    this.$store.dispatch('securitygroups/getSecurityGroups')
    this.interval = setInterval(function () {
      this.refresh()
    }.bind(this), 1000)
  },
  methods: {
    ...mapActions({
      deleteGroup: 'securitygroups/deleteGroup',
      openModal: 'modal/openModal',
      closeModal: 'modal/closeModal'
    }),
    submit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('securitygroups/createNewGroup', this.form)
          this.$store.dispatch('securitygroups/getSecurityGroups')
          this.form = []
        }
      })
    },
    refresh: function () {
      this.$store.dispatch('securitygroups/getSecurityGroups', 0)
    }
  },
  beforeDestroy: function () {
    clearInterval(this.interval)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SecurityGroups.vue